import React from "react";

import { Info } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import FractionFormula from "root/entities/Tooltips/Custom/FractionFormula";

// ----------------------------------------------------------------------------------------------------------------------------------------------------------
const tooltips = {
  nichesPeriod:
    "Выберите один или несколько месяцев для анализа. Если выбрано несколько месяцев (например, декабрь и январь), система автоматически сравнит их с таким же количеством предыдущих месяцев (в этом случае – октябрь и ноябрь). В анализ попадут только те товары, которые появились до первого месяца периода, с которым происходит сравнения (для примера выше - до 1 октября).",
  damping_coefficient: (
    <div style={{ textAlign: "start" }}>
      <b>Коэффициент демпинга</b>
      <ul>
        <li>"Высокий уровень демпинга" - если КД (Коэффициент демпинга) больше 30%</li>
        <li>"Умеренный демпинг" - если КД от 15% до 30%</li>
        <li>"Нет демпинга" - если меньше 15%</li>
      </ul>
      Рассчитывается по формуле:
      <br /> КД = (1 - (средний чек / средняя цена)) × 100%
      {/* <br />
      <br /> Для анализа используются артикулы из топ-100 товаров. */}
    </div>
  ),
  productsCostsEmpty: "Необходимо загрузить данные о себестоимости товаров",
  productsCostsSynced: "Процесс синхронизации запущен, займет до 5 минут",
  productsCostsSyncedForTable: "Идет обновление данных. Завершится в течение 5 минут.",
  product_ads: (
    <Box sx={{ textAlign: "start" }}>
      <Typography fontWeight={500}>Частность артикула.</Typography>
      Показатель отображает количество вбиваний в поисковую строку на WB номера артикула. К
      сожалению, данные по этому полю доступны только до 05.03.2026.
    </Box>
  ),
  er_err: (
    <>
      <span>ER и ERR — показатели вовлеченности аудитории.</span>
      <br />
      <span>
        <strong>ER (Engagement Rate)</strong> показывает, как активно подписчики взаимодействуют с
        контентом: лайки, комментарии, репосты, сохранения. <br />
        <strong>Формула:</strong> (лайки + комментарии + репосты + сохранения) / подписчики × 100%
      </span>
      <br />
      <br />
      <span>
        <strong>ERR (Engagement Rate by Reach)</strong> отражает вовлеченность среди всех, кто
        увидел пост.
        <br />
        <strong>Формула:</strong> реакции / охват × 100%
        <br />
        <br />
        Данных может не быть, так как некоторые блогеры отключают реакции на своих публикациях
      </span>
    </>
  ),
  before_after_out_of_stock: (
    <>
      <b>Обнуление остатков в период 3-х дней до/после публикации.</b>
      <br />В расчет данного показателя берутся последние известные посты за 3 месяца до выбранной
      даты отсчета.
    </>
  ),
  er_err_avg: (
    <>
      <span>ER и ERR — показатели вовлеченности аудитории.</span>
      <br />
      <span>
        <strong>ER (Engagement Rate)</strong> показывает, как активно подписчики взаимодействуют с
        контентом: лайки, комментарии, репосты, сохранения. <br />
        <strong>Формула:</strong> (лайки + комментарии + репосты + сохранения) / подписчики × 100%
      </span>
      <br />
      <br />
      <span>
        <strong>ERR (Engagement Rate by Reach)</strong> отражает вовлеченность среди всех, кто
        увидел пост.
        <br />
        <strong>Формула:</strong> реакции / охват × 100%
        <br />
        <br />
        Средние значения считаются как среднее арифметическое ER и ERR по всем постам с рекламой WB
        за последние 3 месяца.
        <br />
        <br />
        Данных может не быть, так как некоторые блогеры отключают реакции на своих публикациях
      </span>
    </>
  ),
  mapped_article: (
    <span>
      <strong>Подменный артикул</strong> - артикул, который использовался вместо оригинального.{" "}
    </span>
  ),
  w_proceeds_slash_w_orders: (
    <>
      <b>Расчетная выручка и расчетные заказы от интеграции за 3 дня после публикации.</b>
      <br />В расчет данного показателя берутся последние известные посты за выбранный период.
    </>
  ),
  DRR: "Доля рекламных расходов (ДРР) от заказов — это метрика, которая показывает соотношение расходов на рекламу и полученных от неё заказов (не продаж (выкупов), а именно заказов). Чем ниже ДРР, тем более эффективной считается реклама.",
  buyout_percent:
    "Мы считаем % выкупа по логике Wildberries. Формула расчета процента выкупа = кол-во выкупов / (кол-во выкупов  + кол-во отмен)",
  removed_advert: (
    <>
      <b>Внутренняя реклама WB</b>
      <br />С 15.09 WB скрыл возможность аналитики рекламных ставок конкурентов
    </>
  ),
  category_comparison: (
    <Box
      display={"flex"}
      alignItems={"center"}
      border={"1px solid lightgrey"}
      borderRadius={"5px"}
      p={1}
      gap={1}
      mb={1}>
      <Info />
      <Typography variant="subtitle2">
        К сожалению, из-за ограничений в передаче данных по остаткам со стороны WB, аналитика по
        сравнению категорий доступна только по август 2025 года. Рекомендуем воспользоваться
        историческими данными. Например, если вам нужно проанализировать категории, которые растут
        осенний сезон, выберите нужные месяца в прошлом. История повторяется.
      </Typography>
    </Box>
  ),
  monopoly: (
    <>
      Показатель характеризует, какой % выручки приходится на топ-10 артикулов, отсортированных по
      выручке, на первой странице.
      <br />
      <br />
      {/* сумма выручки топ-10 артикулов / сумму выручки топ-100 артикулов в нише. */}
      <FractionFormula
        supText={"Сумма выручки топ-10 артикулов"}
        subText={"Сумма выручки топ-100 артикулов в нише"}
      />
    </>
  ),
  wibesOlderPostDate:
    "До марта 2025 года все посты социальной сети Wibes публиковались в рамках другой платформы WB Guru.",
  haveNoTrends: "Для корректного расчета необходим более длительный период анализа.",
  cerebroDatePicker:
    "В режиме «ЦЕРЕБРО» в этом разделе можно смотреть данные только за последние 30 дней.",
};

export { tooltips };
